import React from 'react'
import PropTypes from 'prop-types'

import { Heading } from 'Components/Blocks/_Legacy'
import { SwiperNarrow, SwiperWide } from 'Components/Blocks/_Legacy/Swipers'
import { Wrapper, WrapperWide } from 'Components/UI/_Legacy/Blueprint'

import { projectGlyph } from 'Assets/_Legacy/BlueprintPage'

import { Container, Content } from './styles'

function ProjectsSwiper({ data, tagTextAs = 'h3' }) {
  const { headerData } = data

  return (
    <Container>
      <Wrapper justifyContent="center">
        <Content mb={[24, 24, 32, 32, 40]}>
          <Heading
            subTitleText={headerData?.subtitleText}
            tagGlyph={projectGlyph}
            tagText={headerData?.overheadText}
            tagTextAs={tagTextAs}
            titleText={{
              first: {
                text: headerData?.titleTextFirst,
                bold: headerData?.firstBold,
              },
              second: {
                text: headerData?.titleTextSecond,
                bold: headerData?.secondBold,
              },
            }}
          />
        </Content>
      </Wrapper>

      <WrapperWide id="SwipersContainer">
        <SwiperNarrow data={data?.projectsData} />

        <SwiperWide data={data?.projectsData} />
      </WrapperWide>
    </Container>
  )
}

ProjectsSwiper.propTypes = {
  data: PropTypes.object,
  tagTextAs: PropTypes.string,
}

export default ProjectsSwiper
